module.exports = __webpack_public_path__ + "img/mask-top.911bef36.png";